import React, { useEffect, useState } from "react"
import { currency } from "../../../constants/constants"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  CardHeader,
  Collapse,
} from "reactstrap"

export default function Summary(props) {
  const cardstyle = {
    height: "130px",
    borderRadius: "15px",
  }
  const currencyStyle = {
    fontSize: "12px",
  }
  const cardHeader = {
    height: "60px",
  }
  const summary = props?.data
  const formatAmount = amount => {
    const roundedAmount = parseFloat(amount).toFixed(2) // Round to 2 decimal places
    return new Intl.NumberFormat().format(roundedAmount) // Format the rounded amount
  }
  return (
    <Card style={{ backgroundColor: "transparent" }}>
      <CardHeader style={{ cursor: "pointer", backgroundColor: "transparent" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "20px",
          }}
        >
          ALL{" "}
        </div>
      </CardHeader>
      <CardBody>
        <Row>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-success text-success"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Bets Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_bet_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card className="border-2 border-info text-info" style={cardstyle}>
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Bets Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_bet_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-danger text-danger"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Bets Winning Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_win_bet_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-secondary text-secondary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Bets Winning Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_win_bet_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-primary text-primary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total WHT Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_wht_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card className="border-2 border-info text-info" style={cardstyle}>
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Sales Excise Tax Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_sales_excise_tax_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-danger text-danger"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Users
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_users.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-secondary text-secondary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Users Balance
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_users_balance)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-primary text-primary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Deposits Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_deposit_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-success text-success"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Deposits Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_deposit_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-primary text-primary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Manual Deposits Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_manual_deposit_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-success text-success"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Manual Deposits Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_manual_deposit_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-danger text-danger"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Withdraws Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_withdraw_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-secondary text-secondary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Withdraws Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_withdraw_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-danger text-danger"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Manual Withdraws Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_manual_withdraw_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-secondary text-secondary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Manual Withdraws Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_manual_withdraw_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-primary text-primary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total 1st Deposit Bonus Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_1st_deposit_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-success text-success"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total 1st Deposit Bonus Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_1st_deposit_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>

          <Col lg={2} className="m-2">
            <Card className="border-2 border-info text-info" style={cardstyle}>
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Signup Bonus Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_signup_bonus_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-secondary text-secondary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Signup Bonus Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_signup_bonus_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>

          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-primary text-primary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Acca7 Bonus Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_acca7_bonus_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-success text-success"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Acca7 Bonus Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_acca7_bonus_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card className="border-2 border-info text-info" style={cardstyle}>
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Loyalty Bonus Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_loyalty_bonus_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-danger text-danger"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Loyalty Bonus Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_loyalty_bonus_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-primary text-primary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Raf Bonus Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_raf_bonus_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-success text-success"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Raf Bonus Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_raf_bonus_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card className="border-2 border-info text-info" style={cardstyle}>
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Manual Bonus Count
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {summary.total_manual_bonus_count.toLocaleString()}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-danger text-danger"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Manual Bonus Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_manual_bonus_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-secondary text-secondary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Multibet Bonus Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_multibet_bonus_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-success text-success"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Net Bets Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_net_bet_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card className="border-2 border-info text-info" style={cardstyle}>
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Total Net Win Amount
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.total_net_win_amount)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-danger text-danger"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                Profit
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.profit)}
                  <span style={currencyStyle}> {currency}</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col lg={2} className="m-2">
            <Card
              className="border-2 border-secondary text-secondary"
              style={cardstyle}
            >
              <CardHeader
                className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                style={cardHeader}
              >
                RTP
              </CardHeader>
              <CardBody>
                <CardText className="font-size-16 font-weight-semibold">
                  {formatAmount(summary.RTP)}
                  <span style={currencyStyle}> %</span>
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}
